import { createAction, props } from '@ngrx/store';
import { getDocumentType } from '../../core/models/Interfaces/documents';

export const addDocument = createAction(
  'add-document',
  props<{
    params: any;
    permitId: number;
    displayType?: string;
    isReadyForReview?: boolean;
  }>(),
);
export const addDocumentSuccess = createAction(
  'add-document-success',
  props<{ data: any }>(),
);
export const addDocumentFailure = createAction('add-document-failure');

export const editDocument = createAction(
  'edit-document',
  props<{ params: any; permitId: number; displayType?: string }>(),
);

export const getDocuments = createAction(
  'get-documents',
  props<{ params: getDocumentType }>(),
);
export const documentsReceived = createAction(
  'documents-received',
  props<{ data: any }>(),
);
export const documentsFailed = createAction('documents-failed');

export const deleteDocument = createAction(
  'delete-document',
  props<{ params: any; permitId?: any; displayType?: string }>(),
);

export const documentsReset = createAction('reset-document');

export const getDocumentTypes = createAction(
  'get-documentTypes',
  props<{ params: getDocumentType }>(),
);
export const getDocumentTypesReceived = createAction(
  'get-documentTypes-Received',
  props<{ data: any }>(),
);
export const getDocumentTypesFailed = createAction('get-documentTypes-Failed');

export const viewDocument = createAction(
  'view-document',
  props<{ params: any }>(),
);

export const downloadDocument = createAction(
  'download-document',
  props<{ params: any }>(),
);
